<template>
  <div>
    <el-dialog
      :visible="delVisible"
      title="删除模拟仓位"
      width="600px"
      @close="closeDialog"
      :before-close="close"
    >
      <el-form
        ref="elForm"
        :model="form"
        size="medium"
        label-width="80px"
        :rules="rules"
      >
        <el-row :gutter="15">
          <el-form-item label="仓位ID" prop="positionId">
            <el-input v-model="form.positionId" placeholder="请输入仓位ID">
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('elForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Del',
  props: [],
  data() {
    return {
      form: { positionId: '' },
      rules: {
        positionId: [
          {
            required: true,
            message: '请输入仓位ID',
          },
        ],
      },
    }
  },
  watch: {
    // delVisible() {
    //   this.elForm = { ...this.updateForm }
    // },
  },
  computed: {
    ...mapState('blocklistManagement', ['delVisible']),
  },
  methods: {
    ...mapMutations('blocklistManagement', ['setDelVisible']),
    ...mapActions('blocklistManagement', ['delPositionId']),
    closeDialog() {
      this.setDelVisible(false)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    close() {
      this.setDelVisible(false)
      this.$refs['elForm'].resetFields()
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.delPositionId({
            positionId: this.form.positionId,
          })
            .then((res) => {
              // this.$message.success('修改成功')
              this.close()
            })
            .catch(() => {
              this.close()
            })
        }
      })
    },
  },
  created() {
    // this.coutryCode();
  },
}
</script>

<style lang="less" scoped>
// ::v-deep.el-select {
// .el-input__inner {
//   width: 100px;
// }
// }
</style>
